function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#0077B5",
  d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z",
  transform: "translate(-1113 -955) translate(1025 903) translate(88 52)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M8.48 9.939v8.17H5.76V9.94h2.72zm.18-2.528c0 .785-.591 1.413-1.54 1.413h-.017C6.19 8.824 5.6 8.196 5.6 7.41 5.6 6.611 6.208 6 7.139 6c.93 0 1.503.61 1.52 1.411zm9.628 6.014v4.685h-2.72v-4.372c0-1.098-.393-1.847-1.378-1.847-.751 0-1.199.505-1.395.993-.072.175-.09.419-.09.663v4.563h-2.72s.036-7.404 0-8.17h2.72v1.156c.361-.556 1.008-1.349 2.452-1.349 1.79 0 3.13 1.168 3.13 3.678z",
  transform: "translate(-1113 -955) translate(1025 903) translate(88 52)"
})))));
const SvgIcSocialLinkedin = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcSocialLinkedin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-social-linkedin.6c8ef256.svg";
export { ForwardRef as ReactComponent };